import React from "react";
import ReactDOM from "react-dom";
import {Overlay, Popover} from "react-bootstrap";
import FlatButton from 'material-ui/FlatButton';
import StyledSelect from 'core/components/fields/styledSelect';
import {fieldStyles} from 'core/form/createForm';
import FaFilter = require("react-icons/lib/fa/filter");
import {MdIconButton} from "core/components/buttons/icons";
import Badge from "material-ui/Badge";
import Grid from "core/grid/domain/grid";
import {observer} from "mobx-react";
import styled from "styled-components";
import {grey400} from "material-ui/styles/colors";



const GridComp__iconStyle = {height: 18, width: 18};
const iconButonStyle = {width: 32, height: 40, padding: "8px 4px"};
const badgeIcon__badgeStyle = {fontSize: 8, width: 12, height: 12};
const badgeIcon__style = {padding: 0};

interface Props {
  grid: Grid;
  search: (scrollToTop?: boolean) => void;
  onGridChange?: Function;
  disabled?: boolean;
}
interface State {
  showPopover?: boolean,
  specialConditions?: any[]
}

const PopoverStyled = styled(Popover)`
    min-width: 300px;
    z-index: 1600px;
`;

const TitleP = styled.p`
    color: ${grey400};
    font-size: 18px;
`;

const ButtonDiv = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
`;

const MainIconDiv = styled.div`
    position: relative;
    vertical-align: top;
    display: inline-block;
`;

@observer
export default class SpecialConditionFilter extends React.Component<Props, State> {

  state = {
    showPopover: false,
    specialConditions: []
  };

  filterIconRef: React.ReactInstance;

  cancelPopover = (evt) => {
    const {grid} = this.props;
    this.setState({
      showPopover: false
    });
  };

  handleSpecialCondition = () => {
    this.setState({
      showPopover: true,
      specialConditions: this.props.grid.specialConditions
    });
  };

  onChangeSpecialCondition = (valueArray) => {
    this.setState({specialConditions: valueArray});
  };

  submitCondition = (evt) => {
    evt.preventDefault();

    const {grid, search, onGridChange} = this.props;

    grid.specialConditions = this.state.specialConditions;
    this.setState({showPopover: false});

    if (onGridChange) {
      onGridChange(grid);
    }

    search(true);
  };


  filterIconRefHandler = comp => this.filterIconRef = comp;
  onHideHandler = () => this.setState({showPopover: false});
  targetHandler = () => ReactDOM.findDOMNode(this.filterIconRef);

  render() {

    let {grid} = this.props;

    const popover = (
      <Overlay
        show={this.state.showPopover}
        onHide={this.onHideHandler}
        rootClose
        target={this.targetHandler}
        placement="bottom">
        <PopoverStyled id="specialConditionFilter">

          <form onSubmit={this.submitCondition}>
            <TitleP>Special Conditions</TitleP>
            <StyledSelect {...fieldStyles.small.styledSelect}
                          onChange={this.onChangeSpecialCondition} value={this.state.specialConditions}
                          options={grid.$gridLocationRef.specialConditions}
                          multi fullWidth searchable={false} clearable={false}/>


            <ButtonDiv>
              <FlatButton type="submit" label="OK" primary/>
              <FlatButton onClick={this.cancelPopover} label="Cancel" secondary />
            </ButtonDiv>
          </form>

        </PopoverStyled>
      </Overlay>
    );

    if (grid.$gridLocationRef.specialConditions && grid.$gridLocationRef.specialConditions.length > 0) {

      const icon = (
        <MdIconButton onClick={this.handleSpecialCondition}
                      style={iconButonStyle}
                      iconStyle={GridComp__iconStyle}
                      disabled={this.props.disabled}>
          <FaFilter size={18}/>
        </MdIconButton>
      );

      const badgeIcon = (
        (grid.specialConditions && grid.specialConditions.length) ?
          <Badge badgeContent={grid.specialConditions.length} primary badgeStyle={badgeIcon__badgeStyle} style={badgeIcon__style}>
            {icon}
          </Badge>
          : icon
      );

      return (
        <MainIconDiv ref={this.filterIconRefHandler}>
          {badgeIcon}
          {popover}
        </MainIconDiv>
      );

    } else {
      return <noscript/>;
    }


  }
}





// WEBPACK FOOTER //
// ./src/core/grid/component/specialConditionFilter.tsx